export default {
	title: "Aggregate feed of activity on this goal and its associated KRs. For a scoped view of activity on a specific KR, navigate to that KR.",
};
